import { Injectable } from '@angular/core';

import { IPromptConfig } from './prompt.interface';

import { ModalService } from '../modal/modal.service';

@Injectable()
export class PromptService {
    constructor(private modalService: ModalService) {}

    open(config: IPromptConfig): Promise<any> {
        config.component.title = config.title;
        config.component.description = config.description;

        return this.modalService.open(config.component.template).result;
    }
}
